import React, { useEffect, useMemo, useState } from 'react'
import TransaksiService from '../services/transaksi/TransaksiService'
import { formatDateStringLocalDateINA } from './Utils'

const GetDokumenTanggal = ({ nomorAju, idJnsDok }) => {
    let transaksiService = useMemo(() => new TransaksiService(), [])
    const [nomorDokumen, setNomorDokumen] = useState('')

    useEffect(() => {
        const getNomorDokumen = async () => {
            try {
                const response = await transaksiService.getPpmDokByAjuKodeDok(nomorAju, idJnsDok)
                setNomorDokumen(response.data.tanggal)
            } catch (error) {
                console.log(error)
                setNomorDokumen('')
            }
        }
        getNomorDokumen()
    }, [transaksiService, nomorAju, idJnsDok])

    return (
        <>
            {nomorDokumen !== '' ? formatDateStringLocalDateINA(nomorDokumen) : '-'}
        </>
    )

}

export default GetDokumenTanggal